import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { User } from './user.model';
import { StorageService } from '../storage/storage.service';
import { Observable, of } from 'rxjs/index';
import { catchError, map } from 'rxjs/internal/operators';

@Injectable()
export class AuthGuard implements CanActivate {

  user: User;

  constructor(private authService: AuthService,
              private http: HttpClient,
              private storage: StorageService,) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Authorization', `Token 5d313cef9f53d007874b31f165b960983c169184`);
    const body = {};
    const url = environment.APIEndpoint + 'client-api/token/';
    return this.authService.isAuthAsync();



    //return this.authService.isAuth();
    // also see https://medium.com/@ryanchenkie_40935/angular-authentication-using-route-guards-bf7a4ca13ae3
  }
}
